type FeedbackAssistantInitOptions = {
  token: string
  getUserToken?: () => string | null | undefined
  routeMode?: 'history' | 'hash'
  ignorePaths?: Array<string | RegExp>
}

declare global {
  interface Window {
    TechforceFeedbackAssistant?: {
      init: (options: FeedbackAssistantInitOptions) => void
    }
  }
}

const feedbackAssistantToken = (import.meta.env.VITE_FEEDBACK_ASSISTANT_TOKEN || '').trim()

function getFeedbackUserToken(): string | null {
  try {
    const user = JSON.parse(window.localStorage.getItem('user') || '{}')
    return user.id != null ? String(user.id) : window.localStorage.getItem('userToken')
  } catch (error) {
    return window.localStorage.getItem('userToken')
  }
}

if (feedbackAssistantToken && window.TechforceFeedbackAssistant) {
  window.TechforceFeedbackAssistant.init({
    token: feedbackAssistantToken,
    getUserToken: getFeedbackUserToken,
    routeMode: 'history',
    ignorePaths: ['/login']
  })
}
